import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Procedure, ProcedureCloneBody, ProcedureContentCloneBody, ProcedureOrder, StepOrder } from "src/app/models/procedure/procedure.model";
import { AuthService } from "../../authentication/auth.service";
import { BaseApiService } from "../../base-api.service";
import { TranslateFirebaseService } from "../../utils/translate-firebase.service";

@Injectable()
export class RestProcedureService extends BaseApiService {
  constructor(httpClient: HttpClient, translate: TranslateFirebaseService, private authService: AuthService) {
    super(httpClient, translate);
  }

  createProcedure(procedure: Procedure): Observable<Procedure> {
    return this.httpClient.post<Procedure>(super.getUpsApiHost() + "InstallationProcedure", procedure, {
      headers: this.authService.upsHttpHeaders,
    });
  }

  updateProcedure(procedure: Procedure): Observable<Procedure> {
    return this.httpClient.put<Procedure>(super.getUpsApiHost() + "InstallationProcedure", procedure, {
      headers: this.authService.upsHttpHeaders,
    });
  }

  deleteProcedure(id: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(super.getUpsApiHost() + "InstallationProcedure/" + id, {
      headers: this.authService.upsHttpHeaders,
    });
  }

  getProcedureById(id: number, languageId: string): Observable<Procedure> {
    return this.httpClient.get<Procedure>(super.getUpsApiHost() + "InstallationProcedure/" + id + "/" + languageId, {
      headers: this.authService.upsHttpHeaders,
    });
  }

  getProceduresByArticleIdAndLanguageId(articleId: number, languageId: string): Observable<Procedure[]> {
    return this.httpClient.get<Procedure[]>(super.getUpsApiHost() + "InstallationProcedure/article/" + articleId + "/" + languageId, {
      headers: this.authService.upsHttpHeaders,
    });
  }

  orderProcedures(orderArray: ProcedureOrder[]): Observable<boolean> {
    return this.httpClient.put<boolean>(super.getUpsApiHost() + "InstallationProcedure/update_procedures_order", orderArray, {
      headers: this.authService.upsHttpHeaders,
    });
  }

  orderSteps(orderArray: StepOrder[]): Observable<boolean> {
    return this.httpClient.put<boolean>(super.getUpsApiHost() + "InstallationProcedure/update_steps_order", orderArray, {
      headers: this.authService.upsHttpHeaders,
    });
  }

  uploadProcedureCSV(importFileData: FormData): Observable<any> {
    return this.httpClient.post<Blob>(super.getUpsApiHost() + "InstallationProcedure/country/importProcedureCSV", importFileData, {
      headers: this.authService.upsHttpHeaders,
      responseType: "blob" as "json",
    });
  }

  downloadProcedureCSV(): Observable<any> {
    return this.httpClient.get(super.getUpsApiHost() + "InstallationProcedure/country/downloadProcedureCSV", {
      headers: this.authService.upsHttpHeaders,
      responseType: "blob" as "json",
    });
  }

  cloneProcedure(procedureData: ProcedureCloneBody, languageId?: string): Observable<any> {
    return this.httpClient.post<any>(`${super.getUpsApiHost()}InstallationProcedure/clone/${languageId}`, procedureData, {
      headers: this.authService.upsHttpHeaders,
    });
  }
  
  cloneProcedureContents(cloneData: ProcedureContentCloneBody, languageId?: string): Observable<any> {
    return this.httpClient.post<any>(`${super.getUpsApiHost()}InstallationProcedure/clone/contents/${languageId}`, cloneData, {
      headers: this.authService.upsHttpHeaders,
    });
  }
}
